export default __webpack_public_path__ + "static/media/JOSA CLASS-9 EXAM PATTERN 2025.b35b0f25.pdf";